import {
  IconBook2,
  IconBooks,
  IconLayoutKanban,
  IconTable,
  IconNotebook,
  IconWriting,
  IconChecklist,
  IconClipboardList,
  IconUsers,
  IconUserScreen,
  IconLockOpen ,
  IconMessageQuestion ,
  IconAward,
  IconDiscount2,
} from "@tabler/icons-react";

// constant
const icons = {
  IconBook2,
  IconBooks,
  IconLayoutKanban,
  IconTable,
  IconNotebook,
  IconWriting,
  IconChecklist,
  IconClipboardList,
  IconUsers,
  IconUserScreen,
  IconLockOpen,
  IconMessageQuestion,
  IconAward,
  IconDiscount2,
};


const utilities = {
  id: "utilities",

  title: "Utilities",

  type: "group",

  children: [
    {
      id: "users",
      title: "Users",
      icon: icons.IconBooks,
      type: "collapse",
      children: [
        {
          id: "user-list",
          title: "User List",
          type: "item",
          url: "/user-list",
          breadcrumbs: true,
        },
        {
          id: "user-time",
          title: "User Time Spend",
          type: "item",
          url: "/user-time",
          breadcrumbs: true,
        },
        
      ],
    },
    {
      id: "properties",
      title: "Properties",
      icon: icons.IconLayoutKanban, // Sections = split layout
      type: "collapse",
      children: [
        {
          id: "properties-list",
          title: "Properties List",
          type: "item",
          url: "/property-list",
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "Reports",
      title: "Reports",
      icon: icons.IconNotebook, 
      type: "collapse",
      children: [
        {
          id: "report-list",
          title: "Report List",
          type: "item",
          url: "/report-list",
          breadcrumbs: true,
        },
      ],
    },
     {
      id: "UserFeatureAccess",
      title: "User Feature Access",
      icon: icons.IconLockOpen, 
      type: "collapse",
      children: [
        {
          id: "UserFeatureAccess",
          
          title: "User Feature Access",
          type: "item",
          url: "/user-feature-access",
          breadcrumbs: true,
        },
      ],
    },

    {
      id: "UserEnquiry",
      title: "User Enquiry",
      icon: icons.IconMessageQuestion, 
      type: "collapse",
      children: [
        {
          id: "UserEnquiry",
          
          title: "User Enquiry",
          type: "item",
          url: "/user-enquiry",
          breadcrumbs: true,
        },
      ],
    },

     {
      id: "BadgeSystem",
      title: "Badge System",
      icon: icons.IconAward, 
      type: "collapse",
      children: [
        {
          id: "BadgeSystemOverview",
          
          title: "Badge System Overview",
          type: "item",
          url: "/badge-system-overview",
          breadcrumbs: true,
        },
      ],
    },

     {
      id: "CouponDiscount",
      title: "Coupons/Discount",
      icon: icons.IconDiscount2, 
      type: "collapse",
      children: [
        {
          id: "CouponDiscount",
          
          title: "Coupons/Discount",
          type: "item",
          url: "/coupons-discount",
          breadcrumbs: true,
        },
      ],
    },
  ],
};

export default utilities;
